import { Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Repeat } from "lib/@components/repeat"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import Iconify from "minimals-template/components/Iconify"
import { TailoredValue } from "../../tailored-value"
import { If } from "lib/@components/switch"
import { isTailoringEvent } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/lib/is-tailoring-event"

export function ReviewAudit({ payload }) {
    if (!isTailoringEvent(payload) || !payload?.tailored) return null

    const { taskTitle, original, tailored } = payload
    let title = taskTitle

    if (taskTitle === "details") {
        title = "Title"
    }

    const updatedOriginal = { ...original, frequency: { label: original.frequency } }
    const updatedtailored = { ...tailored, frequency: { label: tailored.frequency } }
    if (!updatedOriginal.skill && !updatedOriginal.skillSet) {
        updatedOriginal.skillSet = "1"
        updatedOriginal.skill = {
            CoreSkillingID: "1",
            Skilling: "Unknown",
            SkillingCode: "??",
        }
    }
    if (!updatedtailored.skill && !updatedtailored.skillSet) {
        updatedtailored.skillSet = "1"
        updatedOriginal.skill = {
            CoreSkillingID: "1",
            Skilling: "Unknown",
            SkillingCode: "??",
        }
    }
    const scheduleTitle = payload.scheduleTitle ?? ""
    const scheduleCode = payload.scheduleTitle ?? ""
    const currentClassfication = tailored.classification ?? original.classification
    const tailoredEntries = Object.entries(tailored)
        .filter(([t, v]) => v !== null && !t.startsWith("_"))
        .map("0")

    return (
        <Stack sx={{ mb: 2, mt: 1 }} data-cy="review-audit">
            <If truthy={scheduleTitle && scheduleCode}>
                <Typography variant="subtitle2">
                    {scheduleTitle} <small>#{scheduleCode}</small>
                </Typography>
            </If>
            <ListItemBox spacing={1} sx={{ my: 0 }}>
                <Iconify
                    icon={ICON_FROM_CLASSIFICATION[currentClassfication]}
                    sx={{ color: COLOR_FROM_CLASSIFICATION[currentClassfication] }}
                />
                <Typography variant="body2" sx={{ pr: 1 }}>
                    {title}
                </Typography>
            </ListItemBox>
            <Repeat
                list={tailoredEntries}
                item={<TailoredValue original={updatedOriginal} tailored={updatedtailored} />}
            />
        </Stack>
    )
}
